import { create } from 'zustand';
import { ReactNode } from 'react';

interface ITopBarComponent {
  topBarActionComponent: ReactNode;
  setTopBarComponent: (_newNode: ReactNode) => void;
}

export const useTopBarComponent = create<ITopBarComponent>((set) => ({
  topBarActionComponent: null,
  setTopBarComponent: (newNode) => set({ topBarActionComponent: newNode }),
}));
